import React from 'react';
import { ReviewCriteriaByGroupDto } from '../../common/types/ReviewCriteriaTypes';
import { ButtonStyle, ButtonWrapStyle, CriteriaContainerStyle, LabelWrapStyle } from './ReviewCriteriaField.style';
import { ReviewCriteria } from '../../common/types/ReviewCreateRequestType';

type ReviewCriteriaFieldProps = {
  list: ReviewCriteriaByGroupDto[];
  value: ReviewCriteria[];
  onChange: (value: ReviewCriteria[]) => void;
};

const ReviewCriteriaField = (props: ReviewCriteriaFieldProps): JSX.Element => {
  const { list = [], onChange, value } = props;
  const currentIds = value?.map(({ id }) => id) || [];

  return (
    <section>
      {list?.map((item) => {
        const { type, typeLabel, criteria } = item;
        return (
          <CriteriaContainerStyle key={type}>
            <LabelWrapStyle>
              <label>{typeLabel}</label>
            </LabelWrapStyle>
            <ButtonWrapStyle>
              {criteria?.map((item) => {
                const { id, criterion, criterionLabel } = item;
                const isSelected = currentIds.includes(id);
                return (
                  <ButtonStyle
                    key={id}
                    value={criterion}
                    color={isSelected ? 'primary' : 'light'}
                    text={criterionLabel}
                    onClick={(e) => {
                      e.preventDefault();
                      const index = value.findIndex((item) => item.type === type);

                      if (index >= 0) {
                        const newValue = [...value];
                        newValue[index].id = id;
                        onChange(newValue);
                      } else {
                        onChange([...value, { id, type }]);
                      }
                    }}
                  />
                );
              })}
            </ButtonWrapStyle>
          </CriteriaContainerStyle>
        );
      })}
    </section>
  );
};
export default ReviewCriteriaField;
